import Permission from "./Permission";

interface Props {
    permissions: string[];
    onChange: (permissions: string[]) => void;
}

interface Permissions {
    name: string;
    description: string;
    possibleValues: {
        value: string;
        permissions: string[];
    }[];
}

const permissionsList: Permissions[] = [
    {
        name: 'Repository',
        description: 'Permissions related to repository management.',
        possibleValues: [
            {value: 'none', permissions: []},
            {value: 'read', permissions: ['repo.*.read']},
            {value: 'write', permissions: ['repo.*.read', 'repo.*.write']},
        ]
    },
    {
        name: 'Assets',
        description: 'Read assets from repositories',
        possibleValues: [
            {value: 'none', permissions: []},
            {value: 'read', permissions: ['repo.asset.*.read']},
        ]
    },
    {
        name: 'Logs',
        description: 'Read logs from repositories',
        possibleValues: [
            {value: 'none', permissions: []},
            {value: 'read', permissions: ['repo.logs.*.read']},
        ]
    },
    {
        name: 'Deployments',
        description: 'Permissions related to deployment management.',
        possibleValues: [
            {value: 'none', permissions: []},
            {value: 'read', permissions: ['deployment.*.read']},
            {value: 'write', permissions: ['deployment.*.read', 'deployment.*.write']},
        ]
    },
    {
        name: 'Servers',
        description: 'Permissions related to server management.',
        possibleValues: [
            {value: 'none', permissions: []},
            {value: 'read', permissions: ['server.*.read']},
            {value: 'write', permissions: ['server.*.read', 'server.*.write']},
        ]
    },
    {
        name: 'Tasks',
        description: 'Permissions related to task management.',
        possibleValues: [
            {value: 'none', permissions: []},
            {value: 'read', permissions: ['task.*.read']},
            {value: 'write', permissions: ['task.*.read', 'task.*.write']},
        ]
    },
    {
        name: 'User Management',
        description: 'Permissions related to user management.',
        possibleValues: [
            {value: 'none', permissions: []},
            {value: 'read', permissions: ['user.*.read']},
            {value: 'write', permissions: ['user.*.read', 'user.*.write']},
        ]
    }
];

export default function GeneralPermissions({permissions, onChange}: Props) {


    return <>
        {permissionsList.map((permission) => {
            let value = undefined;
            let score = 0;

            for (const p of permission.possibleValues) {
                if (p.permissions.every(perm => permissions.includes(perm))) {
                    const tvalue = p.value;
                    const tscore = p.permissions.length;
                    if (value === undefined || tscore > score) {
                        value = tvalue;
                        score = tscore;
                    }
                }
            }

            return <Permission
                key={permission.name}
                permission={permission.name}
                description={permission.description}
                possibleValues={permission.possibleValues.map(value => value.value)}
                value={value ?? 'none'}
                setPermission={(value: string) => {
                    const newPermissions = permission.possibleValues.find(v => v.value === value)?.permissions || [];
                    const allPermissions: string[] = [];
                    for (const p of permission.possibleValues) {
                        allPermissions.push(...p.permissions);
                    }
                    const filteredPermissions = permissions.filter(p => !allPermissions.includes(p));
                    onChange([...filteredPermissions, ...newPermissions]);

                }}
            />
        })}
    </>

}
